import { render, staticRenderFns } from "./ProductCallback.vue?vue&type=template&id=1bb12d5a&scoped=true&"
import script from "./ProductCallback.vue?vue&type=script&lang=js&"
export * from "./ProductCallback.vue?vue&type=script&lang=js&"
import style0 from "./ProductCallback.vue?vue&type=style&index=0&id=1bb12d5a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb12d5a",
  null
  
)

export default component.exports